function Sidebar() {
  return <></>;
}

export default Sidebar;